'use client'

import React, { type JSX } from 'react'
import classNames from 'classnames'
import Icon, { IconName } from '@dustin-web/microsite-components/src/icon'
import Heading from '@dustin-web/microsite-components/src/heading'
import type { Props as HeadingProps } from '@dustin-web/microsite-components/src/heading'
type Props = {
  title: string
  icon?: IconName
  noIcon?: boolean
  sticky?: boolean,
  stickyOffset?: number
  activeFilters?: JSX.Element | null
  children: React.ReactNode
  withPadding?: boolean
  additionalTopContent?: JSX.Element
  titleClassName?: string
  headerClassName?: string
  className?: string
  ref?: React.RefObject<HTMLDivElement | null> | null
  hTag?: HeadingProps['hTag']
}

export const FilterBox = ({
  title,
  icon = 'settings',
  noIcon = false,
  sticky = false,
  stickyOffset = 0,
  activeFilters,
  children,
  withPadding = false,
  additionalTopContent,
  titleClassName,
  headerClassName,
  className,
  ref,
  hTag = 'h2',
}: Props) => {
  return (
    <div
      ref={ref}
      style={sticky ? { top: stickyOffset } : {}}
      className={classNames('c-box d-print-none u-mb-lg-16 u-px-0 u-py-0',
        className, { 'u-sticky': sticky }
      )}>
      <div className="u-py-12 u-px-16 u-bb u-border-light">
        <div className={classNames('d-flex align-items-center', headerClassName)}>
          {!noIcon && <Icon name={icon} className="i-16 u-mr-8" />}
          <Heading
            hTag={hTag}
            className={classNames('u-mb-0 u-mr-auto u-fs-14 u-fw-bold', titleClassName)}>
            {title}
          </Heading>
          {additionalTopContent && additionalTopContent}
        </div>
        {activeFilters && activeFilters}
      </div>
      <div
        style={sticky ? { maxHeight: `calc(95vh - ${stickyOffset}px)` } : {}}
        className={classNames({
          'u-pt-8 u-pb-16 u-px-16': withPadding,
          'u-overflow-auto u-slim-dustin-scrollbar': sticky
        })}>{children}</div>
    </div>
  )
}
